/**
 * Premium Members Component
 * Modern implementation of the premium members page functionality
 */

export class PremiumMembers {
    constructor() {
        this.isVisible = false;
        this.container = null;
    }

    init() {
        console.log('PremiumMembers: Initializing...');
        this.createPremiumModal();
        this.attachEventListeners();
        console.log('PremiumMembers: Initialized successfully');
    }

    createPremiumModal() {
        this.container = document.createElement('div');
        this.container.className = 'premium-modal-overlay';
        this.container.style.display = 'none';

        this.container.innerHTML = `
            <div class="premium-modal">
                <div class="premium-header">
                    <button class="modal-close" id="premiumClose">
                        <i class="fas fa-times"></i>
                    </button>

                    <!-- Premium badge -->
                    <div class="premium-badge">
                        <i class="fas fa-crown"></i> Premium Access Required
                    </div>

                    <!-- Premium icon -->
                    <div class="premium-icon">
                        <i class="fas fa-lock"></i>
                    </div>

                    <h1 class="premium-title">Premium Members Area</h1>
                </div>

                <div class="premium-content">
                    <!-- Main message explaining premium access -->
                    <div class="premium-message">
                        <p>Access to detailed risk analysis is available to our premium members.</p>

                        <!-- Features list -->
                        <ul class="features-list">
                            <li>Detailed risk assessments for each mining location</li>
                            <li>Historical data and trends</li>
                            <li>Regular updates and alerts</li>
                            <li>Custom reporting and analytics</li>
                            <li>Priority customer support</li>
                        </ul>
                    </div>

                    <!-- Contact information section -->
                    <div class="contact-info">
                        <h3 class="contact-title">
                            <i class="fas fa-envelope"></i> Contact Us
                        </h3>
                        <p>To learn more about our premium services and pricing, please contact us:</p>
                        <p>
                            <strong>Email:</strong>
                            <a href="mailto:info@globalminingrisk.com" class="email-link">
                                info@globalminingrisk.com
                            </a>
                        </p>
                    </div>

                    <!-- Action buttons -->
                    <div class="contact-actions">
                        <button class="contact-redirect-btn" id="contactSalesBtn">
                            <i class="fas fa-envelope"></i> Contact Us for Access
                        </button>
                        <button class="back-button" id="backToMapBtn">
                            <i class="fas fa-arrow-left"></i> Back to Mining Risk Map
                        </button>
                    </div>
                </div>
            </div>
        `;

        document.body.appendChild(this.container);
    }

    attachEventListeners() {
        // Close modal handlers
        const closeBtn = this.container.querySelector('#premiumClose');
        const overlay = this.container;

        closeBtn?.addEventListener('click', () => this.hide());

        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) this.hide();
        });

        // Action button handlers
        const contactSalesBtn = this.container.querySelector('#contactSalesBtn');
        const backToMapBtn = this.container.querySelector('#backToMapBtn');

        contactSalesBtn?.addEventListener('click', () => this.handleContactSales());
        backToMapBtn?.addEventListener('click', () => this.hide());

        // Escape key handler
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isVisible) {
                this.hide();
            }
        });
    }

    handleContactSales() {
        // Open contact form with pre-filled subject
        if (window.contactUs) {
            window.contactUs.show();
            // Pre-fill the subject if contact form supports it
            setTimeout(() => {
                const subjectSelect = document.querySelector('#contactSubject');
                if (subjectSelect) {
                    subjectSelect.value = 'partnership';
                }
                const messageArea = document.querySelector('#contactMessage');
                if (messageArea && !messageArea.value) {
                    messageArea.value = 'I am interested in learning more about premium membership options for Global Mining Risk.';
                }
            }, 100);
        } else {
            // Fallback to direct email
            const subject = encodeURIComponent('Premium Membership Inquiry');
            const body = encodeURIComponent(
                'Hello,\n\nI am interested in learning more about premium membership options for Global Mining Risk.\n\nPlease provide more information about:\n- Pricing details\n- Available features\n- Implementation timeline\n\nThank you!'
            );
            window.location.href = `mailto:info@globalminingrisk.com?subject=${subject}&body=${body}`;
        }

        this.hide();
    }


    showNotification(message, type = 'info') {
        // Use existing notification system if available
        if (window.notificationSystem) {
            if (type === 'success') {
                window.notificationSystem.showSuccess(message);
            } else if (type === 'error') {
                window.notificationSystem.showError(message);
            } else {
                window.notificationSystem.showInfo(message);
            }
        } else {
            // Fallback notification
            alert(message);
        }
    }

    show() {
        console.log('PremiumMembers: show() called');
        console.log('PremiumMembers: container exists:', !!this.container);
        this.isVisible = true;
        this.container.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        console.log('PremiumMembers: Modal should now be visible');
    }

    hide() {
        this.isVisible = false;
        this.container.style.display = 'none';
        document.body.style.overflow = '';
    }

    destroy() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.isVisible = false;
    }
}

// Export singleton instance
export const premiumMembers = new PremiumMembers();